import { useEffect } from 'react';
import { useRouter } from 'next/router';
import * as fbq from '../../lib/facebookPixel';

const gtmPageview = () => {
    window.gtag('event', 'conversion', {
        allow_custom_scripts: true,
        send_to: 'DC-11970753/utiv00/ut-ho0+standard',
    });
};

const pixiePageview = () => {
    window.pixie('event', 'LandingPage');
};

const handleRouteChange = () => {
    fbq.pageview();
    gtmPageview();
    pixiePageview();
};

const TrackingPixels = ({ children }) => {
    const router = useRouter();

    useEffect(() => {
    // This pageview only trigger first time (it is important for Pixel to have real information)
        fbq.pageview();
        gtmPageview();
        pixiePageview();

        router.events.on('routeChangeComplete', handleRouteChange);
        return () => {
            router.events.off('routeChangeComplete', handleRouteChange);
        };
    }, [router.events]);

    return children;
};

export default TrackingPixels;
